export const YOKLAMA_DURUMLARI = [
    { value: ' ', label: 'Seçiniz' },
    { value: 'Devamsız', label: 'Devamsız' },
    { value: 'Geç', label: 'Geç' },
    { value: 'İzinli', label: 'İzinli' },
    { value: 'Yarım Gün', label: 'Yarım Gün' },
    { value: 'Etüt', label: 'Etüt' },
    { value: 'Raporlu', label: 'Raporlu' },
    { value: 'Erken Çıkış', label: 'Erken Çıkış' }
] as const;

export type YoklamaDurumu = typeof YOKLAMA_DURUMLARI[number]['value'];